import './App.css';
import {HashRouter, Route, Switch} from 'react-router-dom';
import './App.css';
import React from 'react';
import Sigin from "./pages/user/sigin"
import Pay from "./pages/pay/pay"
import {handleError,writelog,getVipAwd,svipAwd,setLocalUsrInfo,getLocalUsrInfo,getApiDomain} from './utils'
import QRPay from './pages/pay/qrpay';

export class App extends React.Component {
  constructor(props){
    super(props)
    var usr = getLocalUsrInfo()
    this.state = {
      usrInfo: usr,
      vipAwards: getVipAwd(),
      svipAwards: svipAwd(),
      totalAmount: usr.VIP == 1?29.7:74.7,
      standardPrice: usr.VIP ==1?1.98:4.98,
      realPrice: usr.VIP ==1?1.98:4.98,
      buyHour: 15,
      upgrade: false,
      awardHour: 0,
      tabvalue:0,
      PayQRImg:"",
      TradeNo:"",
      PayChannel:"wxpay",
      TestMode:0
    }

    this.setTotalAmount = this.setTotalAmount.bind(this)
    this.setRealPrice = this.setRealPrice.bind(this)
    this.setBuyHour = this.setBuyHour.bind(this)
    this.setTabValue = this.setTabValue.bind(this)
    this.setAwardHour = this.setAwardHour.bind(this)
    this.setPayQRImg = this.setPayQRImg.bind(this)
    this.setTradeNo = this.setTradeNo.bind(this)
    this.setPayChannel = this.setPayChannel.bind(this)
    this.fetchUsrInfo = this.fetchUsrInfo.bind(this)
    this.setUpgrade = this.setUpgrade.bind(this)

  }

  setUpgrade(value){
    this.setState({
      upgrade:value
    })
  }

  setAwardHour(value){
    this.setState({
      awardHour:value
    })
  }

  setTabValue(value){
    this.setState({
      tabvalue:value
    })
  }

  setPayQRImg(value){
    this.setState({
      PayQRImg: value 
    })
  }

  setTradeNo(value){
    this.setState({
      TradeNo: value 
    })
  }

  setPayChannel(value){
    this.setState({
      PayChannel: value 
    })
  }

  setTotalAmount(value){
    this.setState({
      totalAmount: value 
    })
  }

  setBuyHour(value){
    this.setState({
      buyHour:value
    })
  }

  setRealPrice(value){
    this.setState({
      realPrice: value 
    })
  }

  async fetchUsrInfo(uid,sid){
    if(uid == null || uid == "" || sid == null || sid == ""){
      window.location.href="#/sigin"
      return 
    }
    var reqData ={
        UserID: uid
    }
    let response = await fetch(getApiDomain()+'/users/UserSimpleProfile/'+uid+'?rnd='+Math.random()*999,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'sessionid': sid
        },
        body: JSON.stringify(reqData)
    }).catch(handleError);
    if(response.ok){
        let resData = await response.json();
        if(resData.Result === 0) {
            var usr = {
                UserID: resData.UserID,
                SessionID: resData.SessionID,
                UserName: resData.UserName,
                VIP: resData.VIP,
                LeftLiveTime: resData.LeftLiveTime,
                RunJob: resData.RunJob,
                ChargeMode: resData.ChargeMode, //0: live time 1: month
                SubPlan: resData.SubPlan,
                PushSvr: resData.PushSvr,
                PushCode: resData.PushCode
            } 
            setLocalUsrInfo(usr)

            this.setState({
              usrInfo: usr,
              totalAmount: usr.VIP == 1?29.7:74.7,
              standardPrice: usr.VIP ==1?1.98:4.98,
              realPrice: usr.VIP ==1?1.98:4.98,
            })
        } else {
          var usr = {
            UserID:"",
            SessionID:"",
            UserName:"",
            VIP:1, //0:normal 1:vip 2:svip
            LeftLiveTime:"0", //hour
            RunJob:null,
            ChargeMode:0,
            SubPlan:"$9.98/month",
            PushSvr:"",
            PushCode:""
          }
          setLocalUsrInfo(usr)

          this.setState({
            usrInfo: usr,
            totalAmount: usr.VIP == 1?29.7:74.7,
            standardPrice: usr.VIP ==1?1.98:4.98,
            realPrice: usr.VIP ==1?1.98:4.98,
          })
          
          window.location.href="#/sigin"
          writelog("online pay fetchUsrInfo","resData fail",resData)
        }
    } else {
        if(response.status == 401) {
          window.location.href="#/sigin"
          return 
        }
        writelog("online pay fetchUsrInfo","response fail",response)
    }
  }

  componentDidMount(){

    const urlParams = new URLSearchParams(window.location.search);
    const uid = urlParams.get('uid');
    const sid = urlParams.get('sid');
    const mod = urlParams.get('TestMode');
    const tab = urlParams.get('tab');

    /*
    console.log("uid:",uid)
    console.log("sid:",sid)
    console.log("TestMode:",mod)
    console.log("tab:",tab)
    */

    this.setState({
      TestMode:mod,
      tabvalue:tab=="1"?1:0
    })

    if(uid != null && sid != null){
      this.fetchUsrInfo(uid,sid)
    } else if(getLocalUsrInfo().UserID != "" && getLocalUsrInfo().SessionID != ""){
      //console.log("getLocalUsrInfo:",getLocalUsrInfo())
      this.fetchUsrInfo(getLocalUsrInfo().UserID,getLocalUsrInfo().SessionID)
    } else {
      window.location.href="#/sigin" //todo: for test 
    }
  }


  render() {
    return (
      <HashRouter basename="/onlinepay">
        <Switch>
            <Route exact path="/" render={(props)=><Pay totalAmount={this.state.totalAmount} setTotalAmount={this.setTotalAmount} realPrice={this.state.realPrice} setRealPrice={this.setRealPrice} standardPrice={this.state.standardPrice} svipAwards={this.state.svipAwards} vipAwards={this.state.vipAwards} usrInfo={this.state.usrInfo} PayQRImg={this.state.PayQRImg} setPayQRImg={this.setPayQRImg} TradeNo={this.state.TradeNo} setTradeNo={this.setTradeNo} PayChannel={this.state.PayChannel} setPayChannel={this.setPayChannel} TestMode={this.state.TestMode} buyHour={this.state.buyHour} setBuyHour={this.setBuyHour} tabvalue={this.state.tabvalue} setTabValue={this.setTabValue} awardHour={this.state.awardHour} setAwardHour={this.setAwardHour} upgrade={this.state.upgrade} setUpgrade={this.setUpgrade} />}/>
            <Route export path="/sigin" render={(props)=><Sigin fetchUsrInfo={this.fetchUsrInfo}/>}/>
            <Route export path="/qrpay" render={(props)=><QRPay PayQRImg={this.state.PayQRImg} setPayQRImg={this.setPayQRImg} TradeNo={this.state.TradeNo} setTradeNo={this.setTradeNo} PayChannel={this.state.PayChannel} setPayChannel={this.setPayChannel} />}/>
        </Switch>
      </HashRouter>
    )
  }
}

export default App;
